import type { ReactNode } from 'react';

import StatusBadge from './StatusBadge';

type ListCardMetaProps = {
  title: ReactNode;
  currentPage: number;
  maxPage: number;
  total: number;
  pageStart: number;
  pageEnd: number;
  trailing?: ReactNode;
  pagination?: ReactNode;
  headingLevel?: 2 | 3 | 4;
};

export default function ListCardMeta({
  title,
  currentPage,
  maxPage,
  total,
  pageStart,
  pageEnd,
  trailing = null,
  pagination,
  headingLevel = 2,
}: ListCardMetaProps) {
  const safeMaxPage = Math.max(maxPage, 1);
  const Heading = `h${headingLevel}` as const;

  return (
    <div className="border-t border-subtle bg-subtle/70">
      <div className="flex flex-wrap items-center justify-between gap-3 px-4 py-2.5">
        <div className="min-w-0">
          <Heading className="text-card-title text-strong">{title}</Heading>
          <p className="text-caption tabular-nums text-subtle">
            Pagina {currentPage} di {safeMaxPage} · {total} risultati filtrati
          </p>
        </div>

        <div className="flex flex-wrap items-center gap-2">
          <StatusBadge className="tabular-nums">
            {pageStart}-{pageEnd} di {total}
          </StatusBadge>
          {trailing}
        </div>
      </div>

      {pagination ? (
        <div className="flex items-center justify-end border-t border-subtle px-4 py-2">
          {pagination}
        </div>
      ) : null}
    </div>
  );
}
